__turbopack_context__.v({
  "register": "Register-module__A5IXhq__register",
});
